"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Box = _interopRequireDefault(require("@mui/material/Box"));
var _Divider = _interopRequireDefault(require("@mui/material/Divider"));
var _styles = require("../../../../styles");
var _ = require("../../..");
var _NavItem = _interopRequireDefault(require("./components/NavItem"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const SidebarNav = _ref => {
  let {
    pages
  } = _ref;
  const theme = (0, _styles.useTheme)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_.CompanyLogo, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
      paddingX: 2,
      paddingY: 2,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_NavItem.default, {
          title: 'Landings',
          href: []
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_NavItem.default, {
          title: 'Company',
          items: []
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_NavItem.default, {
          title: 'Blog',
          items: []
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_NavItem.default, {
          title: 'Portfolio',
          items: []
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Divider.default, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_NavItem.default, {
          title: 'Account',
          items: []
        })
      })]
    })]
  });
};

/* SidebarNav.propTypes = {
  pages: PropTypes.array.isRequired,
}; */
var _default = exports.default = SidebarNav;